import React from "react"
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import { formatMoney } from "../../../utils/amount"
import { formatDateField } from "../../../utils/date"
import { LuInbox } from "react-icons/lu"

const headerCellSx = {
  fontSize: '13px',
  textTransform: 'uppercase',
  fontWeight: 600,
  color: 'text.secondary',
  backgroundColor: 'var(--color-bg-subtle)',
  borderBottom: 1,
  borderColor: 'divider',
  px: '10px',
  py: 0,
  verticalAlign: 'middle',
  whiteSpace: 'nowrap',
  lineHeight: 1,
}

const bodyCellSx = {
  fontSize: '0.875rem',
  fontWeight: 400,
  borderBottom: 1,
  borderColor: 'divider',
  color: 'text.primary',
  px: '10px',
  py: 0,
  verticalAlign: 'middle',
}

export const PaymentTable = ({ data = [] }) => {
  if (!data || data.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center gap-2 min-h-[300px] py-12 text-text-secondary">
        <LuInbox size={32} />
        <span style={{ fontSize: 14 }}>No rows</span>
      </div>
    )
  }

  return (
    <TableContainer sx={{ maxHeight: 600, border: 'none' }}>
      <Table stickyHeader size="small" sx={{ border: 'none' }}>
        <TableHead>
          <TableRow sx={{ height: 56 }}>
            <TableCell sx={{ ...headerCellSx, width: 100 }}>Pmt#</TableCell>
            <TableCell sx={headerCellSx}>Payment Date</TableCell>
            <TableCell sx={headerCellSx}>Amount</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, index) => (
            <TableRow
              key={index}
              hover
              className={row.status === 'Failed' ? 'bg-error-light' : ''}
              sx={{ height: 75, '&:hover': { backgroundColor: 'action.hover' } }}
            >
              <TableCell sx={{ ...bodyCellSx, width: 100 }}>{row.pmt || index + 1}</TableCell>
              <TableCell sx={bodyCellSx}>{formatDateField(row.dueDate)}</TableCell>
              <TableCell sx={bodyCellSx}>{formatMoney(row.amount)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
